import { BrandMark } from '../brand/BrandMark';
import { CONTACT_EMAIL, SITE, sectionId } from '../content/site';
import { ROUTES, useLocale } from '../i18n/locale';
import { LanguageSwitch } from './LanguageSwitch';

/**
 * Production footer: mark, descriptor, statement, navigation, language and the verified contact
 * route only. No legal entity, NIT, address, phone or policy is shown until it is verified.
 */
export function SiteFooter() {
  const { locale, page } = useLocale(); const copy = SITE[locale];
  const anchor = (key: Parameters<typeof sectionId>[0]) => `${page === 'home' ? '' : ROUTES.home[locale]}#${sectionId(key, locale)}`;
  return (
    <footer className="site-footer" data-tone="dark">
      <div className="wrap site-footer__inner">
        <div className="site-footer__brand">
          <BrandMark layout="horizontal" tone="dark" className="site-footer__logo" />
          <p className="site-footer__descriptor">{copy.descriptor}</p>
          <p>{copy.statement}</p>
        </div>
        <nav aria-label={copy.footerNav} className="site-footer__nav">
          <ul role="list">
            {copy.nav.map(item => <li key={item.key}><a href={anchor(item.key)}>{item.label}</a></li>)}
            <li><a href={ROUTES.intake[locale]}>{copy.start}</a></li>
            {CONTACT_EMAIL && <li><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>}
          </ul>
        </nav>
        <div className="site-footer__legal">
          <p>© {new Date().getFullYear()} COLESCOMEX. {copy.rights}</p>
          <LanguageSwitch className="site-footer__lang" />
        </div>
      </div>
    </footer>
  );
}
